import { render, staticRenderFns } from "./privacy_policy.vue?vue&type=template&id=a111d29c&scoped=true&"
import script from "./privacy_policy.vue?vue&type=script&lang=js&"
export * from "./privacy_policy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a111d29c",
  null
  
)

export default component.exports